import * as React from "react";
import {MouseEvent} from "react";
import User from "../../_data/models/User";

interface Props {
    loadStyles: (id: number, e: MouseEvent<HTMLElement>) => void;
    loadLikedStyles: (id: number, e: MouseEvent<HTMLElement>) => void;
    loadSpecials: (id: number, e: MouseEvent<HTMLElement>) => void;
    styleLoad: boolean;
    likedStyleLoad: boolean;
    profile: User;
}


const MyProfileTabsComponent = (props: Props) => {
    const {
        loadStyles, loadLikedStyles, loadSpecials, styleLoad, likedStyleLoad, profile
    } = props;

    return (
        <ul className="tabs expanded" data-tabs id="users">
            <li className="tabs-title text-center is-active">
                <a href="" aria-selected={styleLoad} onClick={(e) => loadStyles(profile.id, e)}>My Images</a>
            </li>
            <li className="tabs-title text-center">
                <a href="" aria-selected={likedStyleLoad} onClick={(e) => loadLikedStyles(profile.id, e)}>Liked
                    Images</a>
            </li >
            { profile.isProfessional &&
            <li className="tabs-title text-center">
                <a href="" aria-selected={!styleLoad && !likedStyleLoad} onClick={(e) => loadSpecials(profile.id, e)}>Specials</a>
            </li>}
        </ul>
    );
};

export default MyProfileTabsComponent;


// WEBPACK FOOTER //
// ./app/client/user/components/MyProfileTabsComponent.tsx